import { api } from '../utils'
import { notificate } from './notification'
import { beforeSend, afterResponse } from './'

const identifier = 'color'

export const loadColors = token => {
  return dispatch => {
    dispatch(beforeSend(identifier))
    api.get('admin/colors', {}, token)
      .then(result => {
        if (result.success) {
          dispatch({
            type: 'SET_COLORS',
            data: result.data
          })
        }
        dispatch(afterResponse(identifier))
      })
      .catch(error => {
        dispatch(notificate(error.message, 'error'))
        dispatch(afterResponse(identifier))
      })
  }
}

export const createColor = (data, token) => {
  return dispatch => {
    dispatch(beforeSend(identifier))
    api.post('admin/colors', data, token)
      .then(result => {
        if (result.success) {
          dispatch({
            type: 'SET_COLOR',
            data: result.data
          })
        } else {
          dispatch(notificate(result.message, 'error'))
        }
        dispatch(afterResponse(identifier))
      })
      .catch(error => {
        dispatch(notificate(error.message, 'error'))
        dispatch(afterResponse(identifier))
      })
  }
}

export const updateColor = (data, token) => {
  return dispatch => {
    dispatch(beforeSend(identifier))
    api.put(`admin/colors/${data.id}`, data, token)
      .then(result => {
        if (result.success) {
          dispatch({
            type: 'UPDATE_COLOR',
            data: result.data
          })
        } else {
          dispatch(notificate(result.message, 'error'))
        }
        dispatch(afterResponse(identifier))
      })
      .catch(error => {
        dispatch(notificate(error.message, 'error'))
        dispatch(afterResponse(identifier))
      })
  }
}

export const deleteColor = (id, token) => {
  return dispatch => {
    dispatch(beforeSend(identifier))
    api.delete(`admin/colors/${id}`, {}, token)
      .then(result => {
        if (result.success) {
          dispatch({
            type: 'DELETE_COLOR',
            id
          })
        } else {
          dispatch(notificate(result.message, 'error'))
        }
        dispatch(afterResponse(identifier))
      })
      .catch(error => {
        dispatch(notificate(error.message, 'error'))
        dispatch(afterResponse(identifier))
      })
  }
}
